import {
  Box,
  Dialog,
  DialogTitle,
  Typography,
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import CustomButton from 'components/CustomButton';
import Loader from 'components/Loader';

import { applyPOSDiscount, getPOSDiscounts } from 'services/POS';

import { POSDiscount } from 'types/pos.interface';
import { handleApiErrors } from 'utils/errorUtils';

import {
  ButtonCodeField,
  DiscountField,
  DiscountsContainer,
  StyledCustomInput,
  Label,
  PromotionContainer,
} from './index.styled';

type DiscountModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccessHandler: () => void;
};

const DiscountModal: FC<DiscountModalProps> = ({
  open,
  onClose,
  onSuccessHandler,
}) => {
  const params = useParams();
  const [discountCode, setDiscountCode] = useState<string>('');
  const [discounts, setDiscounts] = useState<POSDiscount[]>([]);
  const [discountsLoading, setDiscountsLoading] = useState<boolean>(false);

  const handleDeliveryCode = (value: string) => {
    setDiscountCode(value);
  };

  const handleApplyPromotion = () => {
    // to be implemented when Update Order endpoint done
    onClose();
  };

  const getDiscounts = async () => {
    try {
      setDiscountsLoading(true);
      const { data } = await getPOSDiscounts();
      setDiscounts(data);
    } catch (err) {
      handleApiErrors(err);
    } finally {
      setDiscountsLoading(false);
    }
  };

  const applyDiscount = async (discountId: number) => {
    if (!params.orderId) {
      return;
    }

    try {
      await applyPOSDiscount(discountId, params.orderId);
      onSuccessHandler();
    } catch (err) {
      handleApiErrors(err);
    }
  };

  useEffect(() => {
    getDiscounts();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="discount-modal-title"
      aria-describedby="discount-modal-description"
    >
      <DialogTitle>Discounts</DialogTitle>
      {discountsLoading && <Loader />}

      {!discountsLoading && !discounts.length && <Typography>No discounts found</Typography>}

      {!discountsLoading && discounts.length && (
        <PromotionContainer>
          <Box display="flex">
            <StyledCustomInput
              value={discountCode}
              onChange={(e) => handleDeliveryCode(e.target.value)}
              label="Promotion Code"
              size="small"
            />
            <ButtonCodeField>
              <CustomButton
                id="button-promotionCode"
                onClick={handleApplyPromotion}
              >
                Apply Code
              </CustomButton>
            </ButtonCodeField>
          </Box>

          <Label>DISCOUNT</Label>

          <DiscountsContainer>
            {discounts.map((discount, index) => (
              <DiscountField key={`${discount.title}-${index}`}>
                <Typography fontWeight="bold" flex={1}>{discount.title}</Typography>
                <Typography flex={1}>{discount.adjustmentType}</Typography>
                <CustomButton
                  onClick={() => applyDiscount(discount.id)}
                  id="button-cartAjustment"
                >
                  Apply
                </CustomButton>
              </DiscountField>
            ))}
          </DiscountsContainer>
        </PromotionContainer>
      )}
    </Dialog>
  );
};

export default DiscountModal;
